import React from "react";

export default function Field({
  label,
  error,
  helper,
  value,
  children,
}) {
  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-tok-xs font-medium text-[rgb(var(--color-text-muted))]">
          {label}
        </label>
      )}
      {value !== undefined
        ? <span className="block text-tok-sm text-[rgb(var(--color-text))]">{value}</span>
        : children}
      {helper && !error && (
        <p className="text-tok-xs text-[rgb(var(--color-text-muted))]">{helper}</p>
      )}
      {error && (
        <p className="text-tok-xs text-[rgb(var(--color-danger))]">{error}</p>
      )}
    </div>
  );
}
